import Drawer from "../../../../drawer/Drawer";
import ManageOrganization from "../ManageOrganization";

const ManageOrganizationDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl3"}
      size={"xl3"}
      title={
        data?._id ? (
          <span className="tracking-tighter uppercase font-bold">
            Update Organization
          </span>
        ) : (
          <span className="tracking-tighter uppercase font-bold">
            Add Organization
          </span>
        )
      }
      subtitle="View, update and modify user details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-90px)]"
    >
      <div className="h-full overflow-y-auto">
        <ManageOrganization
          getResponse={getResponse}
          close={close}
          data={data}
        />
      </div>
    </Drawer>
  );
};

export default ManageOrganizationDrawer;
